import React from 'react';
import useKeyModRerender from '../hooks/useKeyModRerender';

const Radio = ({
  children,
  id,
  value,
  checked,
  customModifier = null,
  disabled,
  hideRadioButtonCircle,
  className,
  analyticsKey,
  analyticsKey2,
  onChange,
  el = 'radio',
  name = '',
  tabIndex = '0',
}) => {
  const keyMod = useKeyModRerender(checked);
  const combinedClassName = [
    customModifier ? `custom-control--${customModifier}` : 'control',
    disabled ? 'control--disabled' : '',
    className,
  ]
    .filter((x) => x)
    .join(' ');

  return (
    <label className={combinedClassName} data-dtm={analyticsKey}>
      <div className="radio-container">
        <div className="radio-container-spacer"></div>
        <input
          key={keyMod}
          className="stat-radio"
          name={name}
          tabIndex={tabIndex}
          type={el}
          id={id}
          value={value}
          checked={checked}
          disabled={disabled}
          data-dtm={analyticsKey}
          data-dtm2={analyticsKey2}
          onChange={() => {
            onChange && onChange();
          }}
        />
        {hideRadioButtonCircle ? null : <span className="control__indicator" />}
      </div>
      {children}
    </label>
  );
};

export default Radio;
